module.exports = __webpack_public_path__ + "static/fonts/Poppins-Bold.08c20a48.ttf";